export default "__VITE_ASSET__c6722a2e__"